import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { LoginComponent } from './login.component';

const routes: Routes = [{ path: 'login', component: LoginComponent, data: { title: 'Login' } }];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslocoModule],
  exports: [RouterModule],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'login' }],
})
export class AuthRoutingModule {}
